const baseUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000'
    : process.env.REACT_APP_API_URL;

export function post(path, body) {
    return fetch(`${baseUrl}${path}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
}

export function get(path) {
    return fetch(`${baseUrl}${path}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
}